import { Component, Input, WritableSignal, OnInit, inject, DestroyRef, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxSliderModule, Options, ChangeContext } from 'ngx-slider-v2';
import { TranslocoPipe } from '@ngneat/transloco';
import { Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { INITIAL_FAST_VALUE, INITIAL_FLAT_VALUE } from '@features/planification-map/components/route-form/components/route-form-options-panels/components/route-form-more-options/constants';

@Component({
  selector: 'app-bicycle-form',
  standalone: true,
  imports: [CommonModule, NgxSliderModule, TranslocoPipe],
  templateUrl: './bicycle-form.component.html',
  styleUrls: ['./bicycle-form.component.scss']
})
export class BicycleFormComponent implements OnInit {

  @Input({required: true}) fast!: WritableSignal<number>; 
  @Input({required: true}) flat!: WritableSignal<number>;
  @Input({required: true}) bicycleAdapted!: WritableSignal<number>;
  @Input({required: true}) resetObservable!: Observable<boolean>

  private destroyRef = inject(DestroyRef);

  public initialLowValue = INITIAL_FAST_VALUE;
  public initialHighValue = INITIAL_FAST_VALUE + INITIAL_FLAT_VALUE;
  public loading = false;

  public sliderOptions: Options = {
    floor: 0,
    ceil: 100,
    showOuterSelectionBars: true,
  }

  ngOnInit(): void {
    this.initialLowValue = this.fast();
    this.initialHighValue = this.fast() + this.flat();
    this.resetObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
      this.initialLowValue = INITIAL_FAST_VALUE;
      this.initialHighValue = INITIAL_FAST_VALUE + INITIAL_FLAT_VALUE;
    })
  }

  public sliderChange(event:ChangeContext) {
    if (event.highValue === undefined || event.value === undefined) {
      return;
    }
    this.initialLowValue = event.value;
    this.initialHighValue = event.highValue;
    this.fast.set(event.value);
    this.flat.set(event.highValue - event.value);
    this.bicycleAdapted.set(100 - event.highValue);
  }


}
